import axios from '@/axios/index'

// 评论分布接口
export function getAnalusisPie(data) {
  return axios({
    url: '/api/banner/comment/analyze/pie',
    method: 'post',
    data
  })
}

// 评论趋势接口
export function getAnalysisTrend(data) {
  return axios({
    url: '/api/banner/comment/analyze/trend',
    method: 'post',
    data
  })
}

// 评论关注点接口
export function getAnalysisAttention(data) {
  return axios({
    url: '/api/banner/comment/analyze/attention',
    method: 'post',
    data
  })
}

// 评论明细接口
export function getAnalysisDetail(data) {
  return axios({
    url: '/api/banner/comment/analyze/detail',
    method: 'post',
    data
  })
}

// 交叉分析标签接口
export function getOverlappLabel(data) {
  return axios({
    url: '/api/label/overlapping/label',
    method: 'post',
    data
  })
}

// 交叉分析
export function getOverlapp(data = {}) {
  return axios({
    url: '/api/banner/comment/overlapping/analyze',
    method: 'post',
    data
  })
}
